import { createListViewContainer } from 'factories/ListView'
import selectors from 'selectors'
import actions from 'actions/notifications'
import Component from 'components/Notifications'

export default createListViewContainer({ actions, selectors: selectors.notifications })(Component)
